import { extraNetworkActionsCreator } from '../../../../../admincore'

const actions = {
  ...extraNetworkActionsCreator('CREATE', 'account/create'),
}

export default actions

export function create(params) {
  return {
    type: actions.CREATE,
    payload: {
      params,
    },
  }
}
